<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Liver Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="testDate"
              disabled
              label="Test Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="testDateOATS"
              disabled
              label="Test Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="serumBilirubin"
              disabled
              label="Serum Bilirubin"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumBilirubinOATS"
              disabled
              label="Serum Bilirubin"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="inr"
              disabled
              label="INR"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="inrOATS"
              disabled
              label="INR"
            />
          </div>
        </div>
    
        
   
        <!-- <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="serumSodium"
              disabled
              label="Serum Sodium"
            />
          </div> 
          <div class="col-2">
            <ADSTextInput
              v-model="serumSodiumOATS"
              disabled
              label="Serum Sodium"
            />
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinineOATS"
              disabled
              label="Serum Creatinine"
            />
          </div>
        </div> -->

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="serumAlbumin"
              disabled
              label="Serum Albumin"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="serumAlbuminOATS"
              disabled
              label="Serum Albumin"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="growthFailure"
              disabled
              label="Growth Failure"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="growthFailureOATS"
              disabled
              label="Growth Failure"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="pediatricConditions"
              disabled
              label="Pediatric Conditions"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="pediatricConditionsOATS"
              disabled
              label="Pediatric Conditions"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="exceptionDiseases"
              disabled
              label="Exception Diseases"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="exceptionDiseasesOATS"
              disabled
              label="Exception Diseases"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="generalComments"
              disabled
              label="General Comments"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="generalCommentsOATS"
              disabled
              label="General Comments"
            />
          </div>
        </div>


        <!-- <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="recentDialysisAndCreatinineTest"
              disabled
              label="Recent Dialysis and Creatinine Test"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="recentDialysisAndCreatinineTestOATS"
              disabled
              label="Recent Dialysis and Creatinine Test"
            />
          </div>
        </div> -->
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "LiverSpecificSectionEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      testDate: this.getTestDate( this.patientBundle ),
     // serumCreatinine: this.getSerumCreatinine( this.patientBundle ),
      inr: this.getINR( this.patientBundle ),
     // serumSodium: this.getSerumSodium( this.patientBundle ), 
      serumAlbumin: this.getSerumAlbumin( this.patientBundle ), 
      recentDialysisAndCreatinineTest: this.getRecentDialysisAndCreatinineTest( this.patientBundle ),
      serumBilirubin: this.getSerumBilirubin( this.patientBundle ),
      growthFailure: this.getGrowthFailure( this.patientBundle ),
      testDateOATS: this.getTestDateOATS( this.patientBundleOATS ),
      serumBilirubinOATS: this.getSerumBilirubinOATS( this.patientBundleOATS ),
      inrOATS: this.getINROATS( this.patientBundleOATS ),
     // serumSodiumOATS: this.getSerumSodiumOATS( this.patientBundleOATS ),
      //serumCreatinineOATS: this.getSerumCreatinineOATS( this.patientBundleOATS ),
      serumAlbuminOATS: this.getSerumAlbuminOATS( this.patientBundleOATS ),
     // recentDialysisAndCreatinineTestOATS: this.getRecentDialysisAndCreatinineTestOATS( this.patientBundleOATS ),
      growthFailureOATS: this.getGrowthFailureOATS( this.patientBundleOATS ),
      pediatricConditions: this.getPediatricConditions( this.patientBundle ),
      generalComments: this.getGeneralComments( this.patientBundle ),
      pediatricConditionsOATS: this.getPediatricConditionsOATS( this.patientBundleOATS ),
      generalCommentsOATS: this.getGeneralCommentsOATS( this.patientBundleOATS ),
      exceptionDiseases: this.getExceptionDiseases( this.patientBundle ),
      exceptionDiseasesOATS: this.getExceptionDiseasesOATS( this.patientBundleOATS ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const components = match[0].resource?.component;
      if( !components?.length ) {
        return null;
      }
      const values = components
        .map( ( n ) => _.get( n, valuePath ) )
        .filter( ( v ) => v !== null && v !== undefined )
        .map( ( v ) => String( v ) );
      if( !values.length ) {
        return null;
      }
      return values.join( ', ' );
    },
    getSmartdataComponentFirstValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const components = match[0].resource?.component;
      if( !components?.length ) {
        return null;
      }
      const values = components
        .map( ( n ) => _.get( n, valuePath ) )
        .filter( ( v ) => v !== null && v !== undefined )
        .map( ( v ) => String( v ) );
      if( !values.length ) {
        return null;
      }
      return values[0];
    },
    getTestDate( patientBundle ) {
      return this.getSmartdataComponentFirstValue( patientBundle, 'SK#8076', 'valueDateTime' );
    },
    // getSerumCreatinine( patientBundle ) {
    //   return this.getSmartdataComponentValue( patientBundle, 'SK#8060' );
    // },
    getINR( patientBundle ) {
      return this.getSmartdataComponentFirstValue( patientBundle, 'SK#8078', ); 
    },
    // getSerumSodium( patientBundle ) {
    //   return this.getSmartdataComponentValue( patientBundle, 'UHN#3964' );
    // },
    getSerumAlbumin( patientBundle ) {
      return this.getSmartdataComponentFirstValue( patientBundle, 'SK#8079' );
    },
    getRecentDialysisAndCreatinineTest( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3797' );
    },
    getSerumBilirubin( patientBundle ) {
      return this.getSmartdataComponentFirstValue( patientBundle, 'SK#8077' );
    },
    getGrowthFailure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8080', 'valueBoolean' );
    },
    getTestDateOATS( patientBundleOATS ) {
      const latestEntry = patientBundleOATS.liver_peld?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
      return latestEntry?.test_date;
      },
    getSerumBilirubinOATS( patientBundleOATS ) {
      const latestEntry = patientBundleOATS.liver_peld?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
      return latestEntry?.serum_bilirubin ? latestEntry?.serum_bilirubin : 'N/A';
    },
    getINROATS( patientBundleOATS ) {
      const latestEntry = patientBundleOATS.liver_peld?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
      return latestEntry?.inr ? latestEntry?.inr : 'N/A';
    },
    // getSerumSodiumOATS( patientBundleOATS ) {
    //   const latestEntry = patientBundleOATS.liver_pelds?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
    //   return latestEntry?.serum_sodium ? latestEntry?.serum_sodium : 'N/A';
    // },
    // getSerumCreatinineOATS( patientBundleOATS ) {
    //   const latestEntry = patientBundleOATS.liver_pelds?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
    //   return latestEntry?.serum_creatinine ? latestEntry?.serum_creatinine : 'N/A';
    // },
    getSerumAlbuminOATS( patientBundleOATS ) {
      const latestEntry = patientBundleOATS.liver_peld?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
      return latestEntry?.albumin ? latestEntry?.serum_albumin : 'N/A';
    },
    // getRecentDialysisAndCreatinineTestOATS( patientBundleOATS ) {
    //   const latestEntry = patientBundleOATS.liver_pelds?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
    //   return latestEntry?.recent_dialysis_and_creatinine_test ? 'Checked' : 'Unchecked';
    // },
    getGrowthFailureOATS( patientBundleOATS ) {
      const latestEntry = patientBundleOATS.liver_peld?.sort( ( a, b ) => new Date( b.test_date ) - new Date( a.test_date ) )[ 0 ];
      return latestEntry?.growth_failure ? 'Checked' : 'Unchecked';
    },
    getPediatricConditions( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8081' );
    },
    getExceptionDiseases( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8485' );
    },
    getGeneralComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8082' );
    },
    getPediatricConditionsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 1 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        let pediatricConditions = journey[ 0 ].organ_specific_details?.pediatric_conditions;
        if( pediatricConditions && pediatricConditions[ 0 ] ) {
            if( pediatricConditions[ 0 ].pediatric_condition_code === 3 ) {
              return 'Gastrointestinal Bleeding/On Intestine List'
        }
        if( pediatricConditions[ 0 ].pediatric_condition_code === 4 ) {
              return 'Renal Failure'
        }
        if( pediatricConditions[ 0 ].pediatric_condition_code === 2 ) {
              return 'Glasgow Coma < 10'
        }
        if( pediatricConditions[ 0 ].pediatric_condition_code === 1 ) {
              return 'On Mechanical Ventilator'
        }
      }
    }
    },
    getExceptionDiseasesOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 1 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        let exceptionDiseases = journey[ 0 ].organ_specific_details?.exception_disease;
        if( exceptionDiseases && exceptionDiseases[ 0 ] ) {
            if( exceptionDiseases[ 0 ].exception_disease_code === 9 ) {
              return 'Metabolic Disorders'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 7 ) {
              return 'Hepatoblastoma'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 13 ) {
              return 'Refractory Pruritus'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 12 ) {
              return 'Primary Sclerosing Cholangitis'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 11 ) {
              return 'Polycystic liver disease'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 6 ) {
              return 'Cystic fibrosis'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 5 ) {
              return 'Cholangiocarcinoma'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 4 ) {
              return 'Failed live donor / DCD graft'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 3 ) {
              return 'Familial amyloid polyneuropathy'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 2 ) {
              return 'Primary hyperoxaluria'
        }
        if( exceptionDiseases[ 0 ].exception_disease_code === 1 ) {
              return 'Severe hepatopulmonary syndrome'
        }
      }
    }
    },
    getGeneralCommentsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 1 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].comments;
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 920px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
